import { useMemo } from 'react';
import { useAdmin } from '../adminContext';
import { hasPermission } from '../session';
import { kitchenApi } from './kitchenApi';

/** Where the kitchen screens run: the store watches its own kitchen and printers; HO reads finished orders (ADR 0027). */
export type KitchenMode = 'store' | 'ho';

export const KITCHEN_READ_PERMISSION: Record<KitchenMode, string> = { store: 'store.kitchen.read', ho: 'ho.kitchen.read' };
export const KITCHEN_REPRINT_PERMISSION = 'store.kitchen.reprint';
export const KITCHEN_DEVICES_PERMISSION = 'store.devices.manage';

/** Live screens poll this often, only while the tab is visible. */
export const KITCHEN_POLL_MS = 15_000;

export const kitchenKey = ['kitchen'] as const;

export const TICKET_STATUSES = ['new', 'in_progress', 'ready', 'bumped', 'recalled', 'voided'] as const;
export const PRINT_STATUSES = ['none', 'queued', 'printed', 'failed'] as const;
export const JOB_STATUSES = ['queued', 'printing', 'printed', 'failed', 'cancelled'] as const;

export function useKitchenApi() {
  const { client } = useAdmin();
  return useMemo(() => kitchenApi(client), [client]);
}

/** Whether this session may see kitchen tickets in this portal. */
export function useCanReadKitchen(mode: KitchenMode) {
  const { session } = useAdmin();
  return hasPermission(session, KITCHEN_READ_PERMISSION[mode]);
}
